export enum VacationScheduleActions {
  Reset = "reset",
  FetchSchedules = "fetchSchedules",
}
